import {SystemFile} from '../../../../../models/system-file.model';
import {FormStatus} from '../../../../../enums/file-status.enum';

export class FileListItem {
    file: File;
    progress = 0;
    systemFile: SystemFile = null;
    status: FormStatus = FormStatus.INIT;
    errorMessage: string[] = [];

    constructor(props = {}) {
        Object.assign(this, props);
    }
}
